import { css } from '@/styled-system/css';

export const flexContainerStyles = css.raw({
  display: 'flex',
  justifyContent: 'space-between',
  height: '800px',
  flexDirection: { base: 'column', md: 'row' },
});

export const easyToBeLandlordBannerStyles = css.raw({
  maxWidth: '350px !important',
  marginLeft: '10%',
  marginTop: 'calc(48px + 10%)',
});

export const startCreatingListingsBannerStyles = css.raw({
  maxWidth: '500px !important',
  alignSelf: 'center',
  top: '15%',
  left: '0',
  right: '0',
  margin: 'auto',
  padding: '600',
  position: 'absolute',
});

export const bottomAlignedImageStyles = css.raw({
  position: 'absolute',
  bottom: '0',
  left: '0',
  right: '0',
  marginLeft: 'auto',
  marginRight: 'auto',
  height: '200px',
});

export const defaultGraphicContainerStyles = css.raw({
  position: 'relative',
  backgroundSize: '100% 100%',
  width: '50%',
  overflow: 'hidden',
  display: { base: 'none', xl: 'block' },
});

export const multifamilyGraphicContainerStyles = css.raw({
  position: 'relative',
  height: '100%',
  width: '50%',
  backgroundColor: '#e5e5e5',
  display: { base: 'none', xl: 'block' },
});

export const bethOnLaptopContainerStyles = css.raw({
  height: '50%',
  width: '100%',
  backgroundColor: '#c1edfe',
  backgroundSize: '100% 100%',
  position: 'absolute',
  bottom: '0',
});
